import { useState } from 'react';
import { PromptProps } from './Common';
import styled from 'styled-components';
import { ErrorHandler, UseUserApiWithHash } from '../../Services/UserApi';
import { Toaster } from 'react-hot-toast';

type PromptResponses = 'signup' | 'dismiss';

export default function SignupToAES(props: PromptProps) {
	const { hash, prompt } = props;
	const [loading, setLoading] = useState(false);
	const [state, setState] = useState<PromptResponses | undefined>(undefined);

	const userApi = UseUserApiWithHash(hash);
	const saveResponse = (response: PromptResponses) => {
		setLoading(true);
		userApi({
			route: 'prompt/api',
			data: {
				action: 'save-response',
				promptId: prompt.ClientPromptId,
				response,
			},
			errorMessage: 'Error saving response',
		})
			.then(() => {
				setState(response);
			})
			.catch((e: unknown) => ErrorHandler.toast(e))
			.finally(() => {
				setLoading(false);
			});
	};

	if (state == 'dismiss') return null;

	return (
		<Alert>
			<div className="cta-panel">
				<p>
					GWP is partnering with the Australian School of Employment to offer our vendors 12 months of free
					mentoring which the ASE will run on our behalf to all vendors who sign up for the program. The
					program will offer vendors to start and grow their small or micro businesses with monthly mentoring,
					workshops and financial support.
				</p>
			</div>
			<div className="action-group">
				<LearnMoreLink
					href="https://selfemploymentassistanceprogram.com/goodwillprojects"
					target="_blank"
					rel="noopener noreferrer"
				>
					Click here to learn more
				</LearnMoreLink>
				{state == undefined && (
					<div className="buttons">
						<button
							disabled={loading}
							className={`btn btn-sm sign-me-up ${loading ? 'disabled' : ''}`}
							onClick={() => saveResponse('signup')}
						>
							Sign me up
						</button>
						<button
							disabled={loading}
							className={`btn btn-sm btn-blue no-thanks ${loading ? 'disabled' : ''}`}
							onClick={() => saveResponse('dismiss')}
						>
							No thanks
						</button>
					</div>
				)}
				{state == 'signup' && <div className="signed-up">Signed up</div>}
			</div>
			<Toaster position="bottom-right" />
		</Alert>
	);
}

const LearnMoreLink = styled.a`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: var(--feature-color-100);

	&:hover {
		text-decoration: none;
		cursor: pointer;
		color: var(--feature-color-200);
	}
`;

const Alert = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;
	gap: 2rem;
	margin-top: 1.5rem;
	padding: 2rem;
	box-shadow:
		0 0 0 1px rgba(0, 0, 0, 0.1),
		4px 6px 10px rgba(0, 0, 0, 0.2);
	border-radius: 0.75rem;

	background-image: url('https://goodwillprojects.com.au/wp-content/uploads/2022/03/BrandPattern2.svg');

	color: black;

	.cta-panel {
		--shadow-size: 10px;
		position: relative;
		background: white;
		border: 3px solid black;
		padding: 2rem;
		margin-bottom: var(--shadow-size);

		:after {
			content: '';
			position: absolute;
			top: var(--shadow-size);
			right: calc(0px - var(--shadow-size));
			width: var(--shadow-size);
			height: 100%;
			background: black;
		}

		:before {
			content: '';
			position: absolute;
			bottom: calc(0px - var(--shadow-size));
			right: calc(0px - var(--shadow-size));
			width: 100%;
			height: var(--shadow-size);
			background: black;
		}
	}

	> i {
		margin-right: 1rem;
		font-size: 24px;
	}

	.action-group {
		margin-left: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 1rem;

		.buttons {
			display: flex;
			gap: 1rem;
		}

		.signed-up {
			background: #3b3b3b;
			color: white;
			padding: 0.5rem 1rem;
			border-radius: 0.25rem;
		}
	}

	.sign-me-up {
		background: black;
		color: white;

		&:hover {
			background: #3b3b3b;
			color: white;
		}
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;
